// extracted by mini-css-extract-plugin
export var root = "e5b9bde6fba2f5a19ec1ceb59cf84edf-css";